var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServicesIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.44451 3.74023L4.07812 4.5418C4.07812 5.13711 4.07812 7.46211 4.07812 11.9996C4.07812 16.5371 7.8875 17.7652 9.79219 17.8121C9.5125 20.5152 10.9219 25.9215 16.5 25.9215C22.0781 25.9215 23.25 21.4215 23.25 19.4996C23.25 17.5777 23.25 13.8746 23.25 13.8746",
    stroke: "currentColor",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.79668 17.8121C11.7014 17.7652 15.5107 16.5371 15.5107 11.9996C15.5107 7.46211 15.5107 5.13711 15.5107 4.5418L12.1444 3.74023",
    stroke: "currentColor",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8313 12.0937C25.8313 10.6722 24.6715 9.5125 23.25 9.5125C21.8285 9.5125 20.6687 10.6722 20.6687 12.0937C20.6687 13.5153 21.8285 14.675 23.25 14.675C24.6715 14.675 25.8313 13.5153 25.8313 12.0937Z",
    stroke: "currentColor",
    strokeWidth: 1.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicesIcon);
export default __webpack_public_path__ + "static/media/services_icon.35b28b2ca783b11e657ec33c8e985532.svg";
export { ForwardRef as ReactComponent };